import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { dateTimeToTime } from 'utils/datetime'
import { thumbnailSelector } from 'features/patient-file-thumbnail/thumbnailSlice'
import { favoriteSelector } from 'features/favorite/favoriteSlice'
import { FileContext } from 'features/patient-details/Details'
import ThumbnailComponent from 'components/Thumbnail'

const Thumbnail = ({ data, handleSelectFile, isLoading, handleFavorite, handleClick }) => {
    const img = useSelector(state => thumbnailSelector.selectById(state, data.thumbnailId))
    const isFavorite = useSelector(state => favoriteSelector.selectById(state, data.fileId))
    const { tagFileIds, collectionFileIds, shareFileIds } = useSelector(state => state.thumbnails)
    const hasTags = tagFileIds.includes(data.fileId)
    const hasCollections = collectionFileIds.includes(data.fileId)
    const isShared = shareFileIds.includes(data.fileId)
    const { selectable } = useContext(FileContext)
    const isSelected = selectable.selectedFiles.includes(data.fileId)

    const icons = [
        {
            icon: 'share',
            isActive: Boolean(isShared),
        },
        {
            icon: 'folder',
            isActive: Boolean(hasCollections),
        },
        {
            icon: 'tag',
            isActive: Boolean(hasTags),
        },
    ]

    return (
        <ThumbnailComponent
            onSelect={handleSelectFile}
            isLoading={isLoading && data.thumbnailId && !img}
            onFavorite={() => handleFavorite([data.fileId])}
            isFavorite={Boolean(isFavorite)}
            isSelected={isSelected}
            id={data.fileId}
            time={dateTimeToTime(data.series.acquisitionDateTime)}
            icons={icons.filter(i => i.isActive).map(i => i.icon)}
            fileType={data.thumbnailId ? data.fileType : false}
            url={img?.downloadUrl}
            onClick={() => handleClick(data.fileId)}
        />
    )
}

export default Thumbnail
